var Viktory = Viktory || {};

Viktory.WebformSubmitter = function () {

	var _select = {
		form: 'form.ajax-webform',
		container: '.ajax-webform-container'
	}

	var _init = function () {
		jQuery(_select.form).each(function () {
			jQuery(this).off('submit').on('submit', _handleSubmit);
		});
	}

	var _objectify = function (formArray) {
		//serialize data function
		var result = {};
		for (var i = 0; i < formArray.length; i++) {
			result[formArray[i]['name']] = formArray[i]['value'];
		}
		return result;
	}

	var _handleSubmit = function (e) {
		// prevent form submit & disable submit button
		e.preventDefault();
		var webForm = jQuery(this);
		var submitBtn = webForm.find('button[type=submit]');
		submitBtn.attr('disabled', 'disabled').addClass('disabled');
		// get form url & data
		var url = webForm.attr('action');
		var strFormData = webForm.serialize();
		var objFormData = _objectify(webForm.serializeArray());
		var webFormContainer = webForm.parents(_select.container);
		var webFormName = webForm.data('formname');
		var webFormKey = webForm.data('formkey');
		// post form via ajax
		jQuery.ajax({
			method: 'POST',
			url: url,
			data: strFormData,
			success: function (response) {
				var gaEventData = webForm.data('ga-event');
				jQuery(webFormContainer).html(response.html);
				if (response.result === 'fail') {
					// reattach form submit handler
					_init();
					// broadcast failed event
					jQuery.publish('Viktory.Webforms.Submit.fail');
				} else if (response.result === 'success' && response.debug < 1) {
					// send google analytics event via gtm
					dataLayer.push(gaEventData);
					// broadcast success event
					jQuery.publish('Viktory.Webforms.Submit.success');
				}
			}
		});
	}

	/** PUBLIC API **/
	return {
		init: function () { return _init(); },
	};

}();

jQuery(function () {
	Viktory.WebformSubmitter.init();
});
